module.exports = __webpack_public_path__ + "static/media/Politique-de-protection-des-renseignements-personnels.0bbdfeb3.pdf";